import * as React from 'react';

import { DEFAULT_EQUIPMENT_PLACEHOLDER } from 'ab-common/constants/value';

import CustomScrollbar from 'af-components/CustomScrollbar';

import AvailableEquipment from './AvailableEquipment';
import BorrowedEquipment from './BorrowedEquipment';
import LoanedEquipment from './LoanedEquipment';
import UnavailableEquipment from './UnavailableEquipment';
import ResourcePlaceholder from '../../ResourcePlaceholder';

interface OwnProps {
	dueDate: string;
	isDragAndDropDisabled: boolean;
	hasPermissionsToEditScheduleBoard: boolean;
}

type Props = OwnProps;

const EquipmentSection: React.FC<Props> = (props) => {
	const { dueDate, isDragAndDropDisabled, hasPermissionsToEditScheduleBoard } = props;

	return (
		<CustomScrollbar
			contentWrapperClassName="schedule-board-toolbar-column equipment"
			isHorizontalHidden={true}
			isVerticalHidden={true}
			scrollbarsClassName="schedule-board-toolbar-column-wrapper equipment"
		>
			<ResourcePlaceholder
				dueDate={dueDate}
				isPlaceholder={true}
				label="Equipment PH"
				uniqueCode={DEFAULT_EQUIPMENT_PLACEHOLDER}
			/>
			<AvailableEquipment
				dueDate={dueDate}
				hasPermissionsToEditScheduleBoard={hasPermissionsToEditScheduleBoard}
				isDragAndDropDisabled={isDragAndDropDisabled}
			/>
			<BorrowedEquipment
				dueDate={dueDate}
				hasPermissionsToEditScheduleBoard={hasPermissionsToEditScheduleBoard}
				isDragAndDropDisabled={isDragAndDropDisabled}
			/>
			<UnavailableEquipment
				dueDate={dueDate}
				hasPermissionsToEditScheduleBoard={hasPermissionsToEditScheduleBoard}
				isDragAndDropDisabled={isDragAndDropDisabled}
			/>
			<LoanedEquipment
				dueDate={dueDate}
				hasPermissionsToEditScheduleBoard={hasPermissionsToEditScheduleBoard}
				isDragAndDropDisabled={isDragAndDropDisabled}
			/>
		</CustomScrollbar>
	);
};

export default React.memo(EquipmentSection);
